import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-keep',
    templateUrl: './admin-keep.component.html',
    styleUrl: './admin-keep.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminKeepComponent {

}
